module.exports = __webpack_public_path__ + "static/img/nca1.f2272b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nca1.png
// module id = 4X0h
// module chunks = 108